"use client";
import React, { useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [bgImage, setBgImage] = useState("/assets/footerimg.svg");

  return (
    <div
      className="relative px-6 py-8 md:py-10 md:px-16 lg:p-20 "
      style={{
        backgroundImage: `url('${bgImage}')`,
        backgroundPosition: "center 100%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        transition: "background-image 1s ease-out",
      }}
    >
      <div className="bg-white flex flex-col md:flex-row p-4 md:p-10 xl:p-16 justify-between gap-10">
        <div className="w-full md:w-[30%] lg:w-[35%] flex flex-col gap-6">
          <img
            src={"/assets/vantlogo.svg"}
            className="w-[20%] lg:w-[25%] h-auto"
            alt="vant_logo"
          />
          <p className="text-sm md:text-sm lg:text-sm   w-[90%] xl:w-[70%] ">
            Vant is a leading African fintech platform that simplifies both
            personal and business finances.
          </p>
          <div className="flex justify-center lg:justify-start mt-2 md:mt-5 gap-4">
            <a
              href="https://www.google.com/url?q=https://play.google.com/store/apps/details%3Fid%3Dcom.vant.app%26hl%3Den_US%26referrer%3Dutm_source%253Dgoogle%2526utm_medium%253Dorganic%2526utm_term%253Dvant%2Bapp&sa=U&ved=2ahUKEwixkrSIwpqBAxVgU0EAHVPRDAMQFnoECAUQAg&usg=AOvVaw3iL8zaaBsLYYudFsvEMTLY "
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={"/assets/goggle.svg"}
                className="w-[130px]  h-[36px] md:w-[150px] lg:w-[170px] md:h-[45px] "
                alt="playstore_img"
              />
            </a>

            <a
              href="https://apps.apple.com/ng/app/vant-app/id6464392721"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={"/assets/app.svg"}
                className="w-[130px]  h-[36px] md:w-[150px] lg:w-[170px] md:h-[45px] "
                alt="appstore_img"
              />
            </a>
          </div>
        </div>

        {/* Right Side (Links) */}
        <div className=" md:w-[70%] lg:w-[65%] flex flex-col md:flex-row flex-wrap  items-stretch justify-between w-full gap-y-3 gap-x-6">
          {/* Column 1 */}
          <div className="flex-1 flex flex-col">
            <p className="font-semibold text-sm md:text-base">Company</p>
            <ul className="text-xs md:text-sm font-light flex flex-col gap-y-2 gap-x-4 py-2 lg:py-4">
              <Link className="cursor-pointer" to="/company">
                <li className="cursor-pointer">About Us</li>
              </Link>
              <a href="mailto: support@vantapp.com">
                <li className="cursor-pointer">Contact Us</li>
              </a>
              {/* <li className="cursor-pointer">Blog</li>
              <li className="cursor-pointer">FAQS</li> */}
            </ul>
          </div>

          {/* Column 2 */}
          <div className="flex-1 flex flex-col">
            <p className="font-semibold text-sm md:text-xl lg:text-base">
              Business
            </p>
            <ul className="text-xs md:text-sm font-light flex flex-col gap-y-2 gap-x-4 py-2 lg:py-4">
              <li className="cursor-pointer">Business accounts</li>
              <li className="cursor-pointer">CAC Registration</li>
              <li className="cursor-pointer">Management tools</li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="flex-1 flex flex-col">
            <p className="font-semibold text-sm md:text-xl lg:text-base">
              Developers
            </p>
            <ul className="text-xs md:text-sm font-light flex flex-col gap-y-2 gap-x-4 py-2 lg:py-4">
              <Link
                className="cursor-pointer"
                to="https://vantapi.readme.io/reference/getting-started-with-your-api"
                traget="_blank"
                rel="noreferrer"
              >
                {" "}
                <li className="cursor-pointer">API Documentation</li>{" "}
              </Link>

              {/* <li className="cursor-pointer">Integrations</li>
              <li className="cursor-pointer">Status</li> */}
            </ul>
          </div>

          {/* Column 4 */}
          <div className="flex-1 flex flex-col">
            <p className="font-semibold text-sm md:text-xl lg:text-base">
              Legal
            </p>
            <ul className="text-xs md:text-sm font-light flex flex-col gap-y-2 gap-x-4 py-2 lg:py-4">
              <Link className="cursor-pointer" to="/privacy">
                <li className="cursor-pointer">Privacy Policy</li>
              </Link>
              <Link className="cursor-pointer" to="/terms">
                <li className="cursor-pointer">Terms and Condition</li>
              </Link>
              {/* <li className="cursor-pointer">Security</li> */}
            </ul>
          </div>
        </div>
      </div>
      <div className="border-b-1 text-[#CFCFCF]"></div>
      <div className="bg-white px-5 py-5 md:px-10 md:py-8 xl:px-16 xl:py-8 flex flex-col md:flex-row lg:items-center justify-between gap-y-2">
        <p className="text-black text-xs md:text-sm  font-light">
          ©2025. Vant Inc. All rights reserved
        </p>
        <div className="flex items-center gap-6">
          <Link
            to="https://www.linkedin.com/company/vantafrica"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={"/assets/in.svg"}
              className="h-7 md:h-8"
              alt="linkedin_img"
            />
          </Link>
          <Link
            to="https://x.com/vantappafrica"
            target="_blank"
            rel="noreferrer"
          >
            <img src={"/assets/x.svg"} className="h-7 md:h-8" alt="x_img" />
          </Link>

          <Link
            to="https://www.instagram.com/vantappafrica?igsh=MzRlODBiNWFlZA=="
            target="_blank"
            rel="noreferrer"
          >
            <img src={"/assets/ig.svg"} className="h-7 md:h-8" alt="ig_img" />
          </Link>
        </div>
      </div>
      <div className="bg-white px-5 py-5 md:px-10 md:py-8 xl:px-16 xl:py-8  lg:items-center justify-between gap-y-2">
        <div className="w-full flex text-xs md:text-sm items-center gap-2 mx-auto text-bold">
          <Link
            to="https://services.ndpc.gov.ng/portal/?page=verify-c&d=dn36294120662&id=24054&sn=40fc0a2e43986e15e06547213854b27b&t=dp_registration&tp=nwp_eosic"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/assets/ndpr.PNG"
              alt="ndpr"
              className=" h-[70px] md:h-[85px]"
            />
          </Link>{" "}
          NDPR Compliant
        </div>
        <p className="pb-[40px] text-[12px]">
          <strong>Disclaimer:</strong>Disclaimer: Vant operates as a financial
          technology company and does not provide banking services or hold
          depositor funds. All financial transactions facilitated by Vant are
          conducted in partnership with licensed financial institutions in their
          respective jurisdictions. Vant does not engage in traditional banking
          activities. By accessing or using Vant’s website and services, you
          acknowledge and agree that Vant is not a bank, and all services are
          provided through third-party partners.
          <br />
          <br />
          <strong>Vant</strong> is a trade name of Advant Capitol Ltd, a private
          limited company incorporated in Nigeria. In the United States,
          <strong> Vant</strong> is registered as
          <strong> Vant Inc.</strong> in the state of Delaware.{" "}
          <strong>Vant</strong> is a licensed money lender and a licensed
          Multi-purpose cooperative society in Nigeria.
          <br /> <br />
          <strong>Vant Inc</strong> is a registered MSB with FinCEN United
          States(USA). Deposits are FDIC insured through our banking partners.
          <br /> <br />
          Vant™️ is a registered trademark representing proprietary financial
          management software solutions. This trademark ensures the integrity,
          authenticity, and exclusivity of Vant’s offerings while underscoring
          its commitment to providing secure and reliable financial technology
          services. <br /> <br />
          Copyright ©️ 2025 Vant Inc. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
